var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getAuthTokenAsync } from "./GetAuthToken";
import { executeLpcConfigRequestAsync } from "./LokiConfigRequest";
import { getOrCreateBootstrapperInstance } from "./Utils/BootstrapperInstances";
var maxNumberOfRetries = 2;
var currentNumberOfRetries = 0;
export function getLpcLokiConfigAsync(authToken, bootstrapperConfig, targetWindow) {
    return __awaiter(this, void 0, void 0, function () {
        var lokiConfig, bootstrapperInstance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bootstrapperInstance = getOrCreateBootstrapperInstance(bootstrapperConfig);
                    if (!bootstrapperInstance.lpcConfig) return [3 /*break*/, 1];
                    lokiConfig = bootstrapperInstance.lpcConfig;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getLpcLokiConfigWithRetryAsync(authToken, bootstrapperConfig, targetWindow)];
                case 2:
                    lokiConfig = _a.sent();
                    bootstrapperInstance.lpcConfig = lokiConfig;
                    _a.label = 3;
                case 3: return [2 /*return*/, lokiConfig];
            }
        });
    });
}
function getLpcLokiConfigWithRetryAsync(authToken, bootstrapperConfig, targetWindow) {
    return __awaiter(this, void 0, void 0, function () {
        var lokiConfig, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 8]);
                    return [4 /*yield*/, executeLpcConfigRequestAsync(authToken, bootstrapperConfig, targetWindow)];
                case 1:
                    lokiConfig = _a.sent();
                    return [3 /*break*/, 8];
                case 2:
                    error_1 = _a.sent();
                    if (!(error_1.statusCode && error_1.statusCode === 401)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getAuthTokenAsync(undefined, bootstrapperConfig.getAuthToken, targetWindow)];
                case 3:
                    authToken = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(currentNumberOfRetries < maxNumberOfRetries)) return [3 /*break*/, 6];
                    currentNumberOfRetries++;
                    return [4 /*yield*/, getLpcLokiConfigWithRetryAsync(authToken, bootstrapperConfig, targetWindow)];
                case 5:
                    lokiConfig = _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    error_1.numberOfRetries = currentNumberOfRetries;
                    throw error_1;
                case 7: return [3 /*break*/, 8];
                case 8: return [2 /*return*/, lokiConfig];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0THBjTG9raUNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9HZXRMcGNMb2tpQ29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQ25ELE9BQU8sRUFBRSw0QkFBNEIsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBSW5FLE9BQU8sRUFBRSwrQkFBK0IsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBRWhGLElBQU0sa0JBQWtCLEdBQUcsQ0FBQyxDQUFDO0FBQzdCLElBQUksc0JBQXNCLEdBQUcsQ0FBQyxDQUFDO0FBRS9CLE1BQU0sVUFBZ0IscUJBQXFCLENBQ3pDLFNBQWlCLEVBQ2pCLGtCQUFzQyxFQUN0QyxZQUE0Qjs7Ozs7O29CQUl0QixvQkFBb0IsR0FDeEIsK0JBQStCLENBQUMsa0JBQWtCLENBQUMsQ0FBQzt5QkFDbEQsb0JBQW9CLENBQUMsU0FBUyxFQUE5Qix3QkFBOEI7b0JBQ2hDLFVBQVUsR0FBRyxvQkFBb0IsQ0FBQyxTQUFTLENBQUM7O3dCQUUvQixxQkFBTSw4QkFBOEIsQ0FDL0MsU0FBUyxFQUNULGtCQUFrQixFQUNsQixZQUFZLENBQ2IsRUFBQTs7b0JBSkQsVUFBVSxHQUFHLFNBSVosQ0FBQztvQkFDRixvQkFBb0IsQ0FBQyxTQUFTLEdBQUcsVUFBVSxDQUFDOzt3QkFHOUMsc0JBQU8sVUFBVSxFQUFDOzs7O0NBQ25CO0FBRUQsU0FBZSw4QkFBOEIsQ0FDM0MsU0FBaUIsRUFDakIsa0JBQXNDLEVBQ3RDLFlBQTRCOzs7Ozs7O29CQUtiLHFCQUFNLDRCQUE0QixDQUM3QyxTQUFTLEVBQ1Qsa0JBQWtCLEVBQ2xCLFlBQVksQ0FDYixFQUFBOztvQkFKRCxVQUFVLEdBQUcsU0FJWixDQUFDOzs7O3lCQUdFLENBQUEsT0FBSyxDQUFDLFVBQVUsSUFBSSxPQUFLLENBQUMsVUFBVSxLQUFLLEdBQUcsQ0FBQSxFQUE1Qyx3QkFBNEM7b0JBQ2xDLHFCQUFNLGlCQUFpQixDQUNqQyxTQUFTLEVBQ1Qsa0JBQWtCLENBQUMsWUFBWSxFQUMvQixZQUFZLENBQ2IsRUFBQTs7b0JBSkQsU0FBUyxHQUFHLFNBSVgsQ0FBQzs7O3lCQUdBLENBQUEsc0JBQXNCLEdBQUcsa0JBQWtCLENBQUEsRUFBM0Msd0JBQTJDO29CQUM3QyxzQkFBc0IsRUFBRSxDQUFDO29CQUNaLHFCQUFNLDhCQUE4QixDQUMvQyxTQUFTLEVBQ1Qsa0JBQWtCLEVBQ2xCLFlBQVksQ0FDYixFQUFBOztvQkFKRCxVQUFVLEdBQUcsU0FJWixDQUFDOzs7b0JBRUYsT0FBSyxDQUFDLGVBQWUsR0FBRyxzQkFBc0IsQ0FBQztvQkFDL0MsTUFBTSxPQUFLLENBQUM7O3dCQUloQixzQkFBTyxVQUFVLEVBQUM7Ozs7Q0FDbkIifQ==